import React from 'react';

import { BaseApprovalAlert } from './BaseApprovalAlert';

export const ApprovalRequested: React.FC = () => {
  return (
    <BaseApprovalAlert
      heading='Approval requested'
      message="You've requested approval for this study. Waiting for your account administrator to review."
    />
  );
};
